export default __webpack_public_path__ + "static/0665-a9e9077f78ac1d2132f5c8e8a3d139a5.jpeg";